// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__OLfa4","notes":"Notes_notes__1jcwC","note":"Notes_note__3LoxX","markdown":"Notes_markdown__TWCvo"};